import { PowerSocketIcon } from './PowerSocketIcon';

/**
 * author: Simran
 * id 175A9E67-3723-4D49-85EC-8D34B4BA0C14
 * name power-socket
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket.svg
 * tags
 * - Home Automation 
 */
export const PlugSocketIcon = PowerSocketIcon;
export default PlugSocketIcon